export const HORIZONTAL_NAVIGATION = '__pageLayoutHorizontalNavigation';
export const LEFT_SIDEBAR = '__pageLayoutLeftSidebar';
export const MAIN_CONTENT = '__pageLayoutMainContent';
export const TOP_NAVIGATION = '__pageLayoutTopNavigation';
export const RIGHT_SIDEBAR = '__pageLayoutRightSidebar';

export type PageLayoutField =
	| typeof HORIZONTAL_NAVIGATION
	| typeof LEFT_SIDEBAR
	| typeof RIGHT_SIDEBAR
	| typeof MAIN_CONTENT
	| typeof TOP_NAVIGATION;
